/**
 * Utility for deriving the distance unit (miles vs kilometers) from an address.
 */

/**
 * Derives the distance unit from a Google-formatted address description string.
 * US/UK addresses use miles; everything else uses kilometers. Mirrors the rule
 * previously inlined in AvailabilityForm. The signal is the formatted `name`
 * string (e.g. "123 Main St, Springfield, IL, USA") — no country code is
 * available from the address API, which returns only { id, name }.
 *
 * @param {string} addressName - The formatted address description.
 * @returns {"mi" | "km"} The derived distance unit.
 */
export const deriveDistanceUnit = (addressName) => {
  if (!addressName) return "km";
  const isUSUK =
    addressName.includes(", USA") || addressName.includes(", UK");
  return isUSUK ? "mi" : "km";
};
